/**
 * O emitido SEM viagem como a home do app o recebe (`pendingVouchers` do trip-api, repassado
 * pelo BFF): o `VoucherView` de sempre e, quando o trip-api acha uma, a viagem mais provável
 * dele (#4989). A sugestão nunca vincula sozinha — é a pessoa quem decide.
 *
 * Não confundir com `TripHotelSuggestion` (`trip_suggestion.ts`), que sugere um HOTEL para
 * dentro de uma viagem; aqui é a VIAGEM que se sugere para um voucher.
 *
 * Contrato aditivo: produtor antigo não manda `suggestedTrip`, e o campo só nasce quando há
 * sugestão. Quem revalida a lista com o `VoucherViewSchema` puro descarta o campo em silêncio
 * — repassar a sugestão exige ESTE schema.
 */
import { z } from 'zod';

import { VoucherViewSchema } from './traveler_view';

/**
 * Por que esta viagem, no sinal de maior peso — um motivo por texto da tela:
 * `dates` "As datas batem com esta viagem", `destination` "Mesmo destino desta viagem",
 * `return` "Volta da mesma reserva" (a volta da ida que já está na viagem, ou o mesmo
 * localizador de um voucher dela).
 */
export const SuggestedTripReasonSchema = z.enum(['dates', 'destination', 'return']);
export type SuggestedTripReason = z.infer<typeof SuggestedTripReasonSchema>;

export const SuggestedTripSchema = z.object({
  tripId: z.string().min(1),
  reason: SuggestedTripReasonSchema,
});
export type SuggestedTrip = z.infer<typeof SuggestedTripSchema>;

export const PendingVoucherViewSchema = VoucherViewSchema.extend({
  suggestedTrip: SuggestedTripSchema.optional(),
});
export type PendingVoucherView = z.infer<typeof PendingVoucherViewSchema>;
